import type { PKResult } from "@placekit/client-js";
import { Address } from "types";

export const buildAddress = ({ name, zipcode, city, countrycode }: PKResult): Address => ({
  street_address: name,
  zip_code: zipcode[0],
  city: city,
  country: countrycode.toUpperCase(),
});
